import React, { useState } from "react";
import prevIcon from "../../../../../assets/SVGs/prev-button.svg";
import nextIcon from "../../../../../assets/SVGs/next-button.svg";
import { useTheme } from "../../../../../utils/ThemeContext";
import moment from "moment";
import "../../../disaster/DisasterDashboard/styles/planCalander.css"

const DivorcePlanCalander = ({calanderData}) => {
  const { theme } = useTheme();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedData, setSelectedData] = useState([]);

  const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const today = new Date();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const lastDayOfPrevMonth = new Date(year, month, 0);

  const daysInMonth = lastDayOfMonth.getDate();
  const daysInPrevMonth = lastDayOfPrevMonth.getDate();

  const firstDayIndex = firstDayOfMonth.getDay();
  const lastDayIndex = lastDayOfMonth.getDay();

  const expirationDates = calanderData && calanderData
  .filter(item => item["Expiration Date"])
  .map(item => moment(item["Expiration Date"]).format("YYYY-MM-DD"));

  const dates = [];

  for (let i = firstDayIndex; i > 0; i--) {
    dates.push({
      day: daysInPrevMonth - i + 1,
      currentMonth: false,
    });
  }

  for (let i = 1; i <= daysInMonth; i++) {
    const dateString = moment(new Date(year, month, i)).format("YYYY-MM-DD");
    dates.push({
      day: i,
      currentMonth: true,
      isToday:
        today.getDate() === i &&
        today.getMonth() === month &&
        today.getFullYear() === year,
        isExpiring: expirationDates && expirationDates.includes(dateString),
    });
  }

  for (let i = 1; i < 7 - lastDayIndex; i++) {
    dates.push({
      day: i,
      currentMonth: false,
    });
  }

  const handlePrevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  

  const handleDateClick = (day) => {
    const clickedDate = moment(new Date(year, month, day)).format("YYYY-MM-DD");

    const matchingData = calanderData && calanderData.filter(
      item =>
        item["Expiration Date"] &&
        moment(item["Expiration Date"]).format("YYYY-MM-DD") === clickedDate
    );

    setSelectedData(matchingData);
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
      }}
      className="disaster-small-static-calendar-container"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          height: "80%",
        }}
      >
        <div
          style={{ background: "#E9ECFF", borderRadius: "4px", padding: "8px" }}
        >
          <div
            className="disaster-calendar-header"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* <div className="next-prev-buttons"> */}
            <button onClick={handlePrevMonth}>
              <img
                style={{
                  filter: "invert(1)",
                  width: "24px",
                  height: "24px",
                }}
                src={prevIcon}
                alt=""
              />
            </button>
            <span style={{ color: "rgb(35, 35, 35)" }}>
              {currentDate.toLocaleString("default", { month: "long" })}{" "}
              <span style={{ color: theme === "dark" ? "#1e90ff" : "#1e90ff" }}>
                {year}
              </span>
            </span>
            <button onClick={handleNextMonth}>
              <img
                style={{
                  filter: "invert(1)",
                  width: "24px",
                  height: "24px",
                }}
                src={nextIcon}
                alt=""
              />
            </button>
            {/* </div> */}
          </div>
          <div
            style={{ color: "rgb(35, 35, 35)" }}
            className="disaster-calendar-grid"
          >
            {daysOfWeek.map((day) => (
              <div key={day} className="disaster-calendar-day">
                {day}
              </div>
            ))}
            {dates.map((date, index) => (
              <div
                style={{ color: "rgb(35, 35, 35)" }}
                key={index}
                className={`disaster-calendar-date 
                  ${date.isToday ? "date-today" : ""} 
                  ${date.isExpiring ? "expiring" : ""}`}
                onClick={() => date.currentMonth && handleDateClick(date.day)}
                // className={`disaster-calendar-date ${
                //   date.currentMonth ? "" : "disabled"
                // } ${date.isToday ? "date-today" : ""}`}
              >
                {date.day}
              </div>
            ))}
          </div>
        </div>
        <div
          style={{
            border: "1px solid #99999933",
            marginTop: "1rem",
            color: "#ACB3D6CC",
            padding: "1rem",
          }}
        >
          <div className="weather-card-heading">Your Plans</div>
          {selectedData && selectedData.length > 0 ? (
            <ul>
              {selectedData.map(item => (
                <li key={item.id}>
                  <strong>Module:</strong> {item.module} <br />
                  {item["Document Name"] && <><strong>Document:</strong> {item["Document Name"]} <br /></>}
                  {item["Expiration Date"] && <><strong>Expires:</strong> {moment(item["Expiration Date"]).format("YYYY-MM-DD")} <br /></>}
                </li>
              ))}
            </ul>
          ) : (
            <p>No data for selected date.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DivorcePlanCalander;
